<style>
.center {
  margin: 20px 0 0 20px;
}
</style>
<template>
  <ut-form :label-width="200">
    <ut-form-item>
      <template slot="label">
        <span style="color:red">*</span> 监控名称：
      </template>
      <ut-input placeholder="监控名称" v-model="name" :style="{width:'500px'}"></ut-input>
    </ut-form-item>
    <ut-form-item>
      <template slot="label">
        <span style="color:red">*</span> 监控目标host：
      </template>
      <ut-input placeholder="监控目标host" v-model="host" :style="{width:'500px'}"></ut-input>
    </ut-form-item>

    <ut-form-item>
      <template slot="label">
        <span style="color:red">*</span> 监控目标端口：
      </template>
      <ut-input placeholder="监控目标端口" v-model="port" :style="{width:'500px'}"></ut-input>
    </ut-form-item>

    <ut-form-item>
      <template slot="label">
        <span style="color:red">*</span> 测试端口探测：
      </template>
      <ut-button  type="primary"  @click="test" :disabled="isDisable">测试</ut-button>
    </ut-form-item>
    
    <ut-form-item>
      <template slot="label">
        <span style="color:red">*</span> 请选择应用
      </template>
      <ut-select v-model="selected1" filterable :style="{width:'500px'}" :filter-method='filter'>
        <ut-option v-for="item in appSearchOptions||appOptions" :value="item.appId" :key="item.appId" :label="item.appId"></ut-option>
      </ut-select>
    </ut-form-item>

    <ut-form-item label="">
      <template slot="label">
        <span style="color:red">* </span>报警策略
      </template>
      <ut-select v-model="selected2" filterable :style="{width:'500px'}">
        <ut-option v-for="item in policyOptions" :value="item.id" :key="item.id" :label="item.name"></ut-option>
      </ut-select>
    </ut-form-item>

    <ut-form-item>
      <template slot="label">
        <span style="color:red">*</span> 是否生效：
      </template>
      <ut-radio-group v-model="isEffect">
        <ut-radio-button value="true" >生效</ut-radio-button>
        <ut-radio-button value="false">失效</ut-radio-button>
      </ut-radio-group>
    </ut-form-item>

    <ut-form-item>
      <ut-button type="primary" @click="submit">立即创建</ut-button>
      <ut-button @click="goBack">取消</ut-button>
    </ut-form-item>
  </ut-form>
</template>

<script lang="babel">
export default {
  data() {
    return {
        name:'',
        host:'',
        port:'',
        isDisable:false,
        isEffect:'',
        selected1: '',
        selected2: '',
        appOptions: [],
        appSearchOptions: null,
        policyOptions:[]
    }
  },
  methods:{
    filter (val) {
      const data = []
      this.appOptions.map(item => {
          if (item.appId.toLowerCase().indexOf(val) !== -1 || item.appName.toLowerCase().indexOf(val) !== -1) {
            data.push(item)
          }
      })
      if (data.length) {
        this.appSearchOptions = data;
      } else {
        this.appSearchOptions = [];
      }
    },
    submit(){
      var name = this.name;
      var host = this.host;
      var port = this.port;
      var isEffect = this.isEffect;
      var appId = this.selected1;
      var alarmPolicyId = this.selected2;

      if(name == ""){
        this.$message.error('监控名称不能为空');
        return false;
      }
      if(host == ""){
        this.$message.error('host 不能为空');
        return false;
      }
      if (port == "") {
         this.$message.error('端口不能为空');
        return false;
      }
      if(isEffect == ""){
         this.$message.error('请选择是否生效');
        return false;
      }
      if(this.selected1 == ""){
        this.$message.error('应用不能为空');
        return false;
      }
      if(this.selected2 == ""){
        this.$message.error('报警策略不能为空');
        return false;
      }

      // var ipz= /^(\d+).(\d+).(\d+).(\d+)$/g;
      // if (!new RegExp(ipz).test(host)) {
      //   this.$message.error('不符合IP规则');
      //   return false;
      // }

      var portz= /^(\d)+$/g;
      if(!new RegExp(portz).test(port)){
        this.$message.error('不符合端口规范');
        return false;
      }
      var sendData = {};
      sendData.name = name;
      sendData.appId = appId;
      sendData.alarmPolicyId = alarmPolicyId;
      sendData.host = host;
      sendData.port = port;
      sendData.isEffect= isEffect;
      
      this.$http({
        method: "post",
        url: "ports/add.htm",
        data: JSON.stringify(sendData)
      })
        .then(response => {
          //这里使用了ES6的语法
          console.log(response); //请求成功返回的数据
          if(response.data.code == 0){
            this.$message.success('添加成功');
            this.$router.push({ path: "/ports" });
          }else{
            this.$message.error(response.data.message);
            return false;
          }
        })
        .catch(error => {
          console.log(error); //请求失败返回的数据
        });
    },
    goBack(){
      this.$router.push({ path: "/ports" });
    },
    test(){
      var name = this.name;
      var host = this.host;
      var port = this.port;
      var isEffect = this.isEffect;
      var appId = this.selected1;
      var alarmPolicyId = this.selected2;
      // var ipz= /^(\d+).(\d+).(\d+).(\d+)$/g;
      // if (!new RegExp(ipz).test(host)) {
      //   this.$message.error('不符合IP规则');
      //   return false;
      // }

      var portz= /^(\d)+$/g;
      if(!new RegExp(portz).test(port)){
        this.$message.error('不符合端口规范');
        return false;
      }
      

      if(host == ""){
        this.$message.error('host 不能为空');
        return false;
      }
      if (port == "") {
         this.$message.error('端口不能为空');
        return false;
      }
      
      var sendData = {};
    
      sendData.host = host;
      sendData.port = port;
      this.isDisable = true;
      this.$http({
      method: "post",
      url: "ports/ping.htm",
      data: sendData
      })
      .then(response => {
        //这里使用了ES6的语法
        console.log(response); //请求成功返回的数据
        if(response.data.code == 0){
          this.$message.info("测试成功!");
        }else{
            this.$message.error('连接不通');
        }
        this.isDisable = false;
      })
      .catch(error => {
        this.isDisable = false;
        console.log(error); //请求失败返回的数据
        this.$message.error('连接不通');
      });
    }
  },
  created() {
    // 应用加载
    this.$http({
      method: "post",
      url: "apps/list.htm",
      data: "{}"
    })
      .then(response => {
        //这里使用了ES6的语法
        console.log(response.data.length); //请求成功返回的数据
        this.appOptions = response.data;
      })
      .catch(error => {
        console.log(error); //请求失败返回的数据
      });
    // 报警策略加载
    this.$http({
        method: "post",
        url: "policys/list.htm",
        data: "{}"
      })
        .then(response => {
          //这里使用了ES6的语法
          this.policyOptions = response.data;
        })
        .catch(error => {
          console.log(error); //请求失败返回的数据
        });
  }
}
</script>